export const baxiManufacturerNames = [
  'HEATRAE',
  'POTTERTON',
  'MYSON THORN',
  'BAXI',
  'REMEHA',
  'MAIN',
  'MEGAFLO',
  'SANTON',
];

const baxiManufacturerNameSet = new Set(
  baxiManufacturerNames.map((name) => name.toUpperCase())
);

export function isBaxiManufacturer(
  manufacturerName: string | null | undefined
): boolean {
  return baxiManufacturerNameSet.has(
    (manufacturerName ?? '').trim().toUpperCase()
  );
}
